import { render, staticRenderFns } from "./PhonePlan.vue?vue&type=template&id=1095a31a"
import script from "./PhonePlan.vue?vue&type=script&lang=js"
export * from "./PhonePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports